import React from "react";
import { ModalActionCancel, useModalContext } from "../../../../global/modals";

export const ListingModalSwapCancelBtn = () => {
  const { closeModal } = useModalContext();

  return <ModalActionCancel onClick={closeModal}>Cancel</ModalActionCancel>;
};
